import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';

import { gray1 } from '../styles';

const Wrapper = styled.blockquote`
  margin: 0 24px 24px;
`;

const QuoteContent = styled.div`
  padding: 6px 0 6px 24px;
  border-left: 10px solid ${gray1};
  font-size: 20px;
`;

const Source = styled.div`
  margin-top: 12px;
  padding-left: 34px;
  font-size: 16px;

  &::before {
    content: '\u2013 ';
  }
`;

class Blockquote extends Component {
  static get propTypes() {
    return {
      header: PropTypes.string,
    };
  }

  render() {
    const { children, source } = this.props;
    return (
      <Wrapper>
        <QuoteContent children={children} />
        {source && <Source children={source} />}
      </Wrapper>
    );
  }
}

export default Blockquote;



// WEBPACK FOOTER //
// ./src/components/blockquote.js